import { computed } from "vue";
import { useGameStore } from "@/stores/game";
import { useSessionStore } from "@/stores/session";

/**
 * Итог завершённой игры для экранов /result, /replay, /reward.
 *
 *   const { result, isWinner, reward, looserImgLink, loserName, winnerName, afterReplayPath } = useGameOutcome()
 *
 * isWinner: поле result (WIN/LOSE) из персонального FINAL; для старого сервера — сравнение
 * winnerUserId с моим userId, затем имени победителя с моим именем.
 * afterReplayPath: победитель с наградой → /reward, иначе «/».
 */
export function useGameOutcome() {
  const game = useGameStore();
  const session = useSessionStore();

  const result = computed(() => game.result || {});

  const isWinner = computed(() => {
    const r = result.value;
    if (r.outcome === "WIN") return true;
    if (r.outcome === "LOSE") return false;
    if (session.userId !== null && r.winnerUserId !== null && r.winnerUserId !== undefined) {
      return Number(r.winnerUserId) === Number(session.userId);
    }
    return !!session.me && !!r.winnerName && r.winnerName === session.me.playerName;
  });

  const reward = computed(() => Math.max(0, Number(game.reward) || 0));
  const looserImgLink = computed(() => game.looserImgLink || result.value.looserImgLink || null);

  const myName = computed(() => (session.me ? session.me.playerName : "Вы"));
  const opponentName = computed(() => (game.opponent ? game.opponent.playerName : "Соперник"));
  const winnerName = computed(() => result.value.winnerName || (isWinner.value ? myName.value : opponentName.value));
  const loserName = computed(() => result.value.loserName || (isWinner.value ? opponentName.value : myName.value));

  const afterReplayPath = computed(() => (isWinner.value && reward.value > 0 ? "/reward" : "/"));

  return { result, isWinner, reward, looserImgLink, winnerName, loserName, afterReplayPath };
}

export default useGameOutcome;
